import React, { useState } from 'react';
import { ChevronDown, Globe, Check } from 'lucide-react';
import { useSiteContext } from '../contexts/SiteContext';

const SiteSelector = () => {
  const { selectedSite, sites, selectSite, loading } = useSiteContext();
  const [isOpen, setIsOpen] = useState(false);

  if (loading || sites.length === 0) {
    return (
      <div className="flex items-center space-x-2 text-sm text-gray-500">
        <Globe className="h-4 w-4" />
        <span>No sites available</span>
      </div>
    );
  }

  if (sites.length === 1) {
    return (
      <div className="flex items-center space-x-2 text-sm text-gray-700">
        <Globe className="h-4 w-4 text-blue-600" />
        <span className="font-medium">{selectedSite?.name}</span>
      </div>
    );
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center space-x-2 px-3 py-2 text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
          selectedSite
            ? 'text-gray-700 bg-white border border-gray-300 hover:bg-gray-50'
            : 'text-white bg-blue-600 border border-blue-700 hover:bg-blue-700 animate-pulse'
        }`}
      >
        <Globe className="h-4 w-4" />
        <span>{selectedSite?.name || 'Select a Site'}</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />

          {/* Dropdown */}
          <div className="absolute left-0 z-20 mt-2 w-64 bg-white border border-gray-200 rounded-md shadow-lg">
            <div className="py-1">
              <div className="px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-100">
                Select Site
              </div>
              {sites.map((site) => (
                <button
                  key={site.id}
                  onClick={() => {
                    selectSite(site);
                    setIsOpen(false);
                  }}
                  className="w-full flex items-center justify-between px-4 py-3 text-sm text-gray-700 hover:bg-gray-50"
                >
                  <div className="flex items-center space-x-3">
                    <Globe className="h-4 w-4 text-gray-400" />
                    <div className="text-left">
                      <div className="font-medium">{site.name}</div>
                      <div className="text-xs text-gray-500 truncate max-w-40">
                        {site.url}
                      </div>
                    </div>
                  </div>
                  {selectedSite?.id === site.id && (
                    <Check className="h-4 w-4 text-blue-600" />
                  )}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SiteSelector;